import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Box from '@mui/material/Box';

type Props = {
  value: Dayjs | null;
  handleChange: (value: Dayjs | null) => void;
  userTimeFormat?: string; // Optional prop for custom time format
};

const CustomPropertyTimePicker = ({ value, handleChange, userTimeFormat }: Props) => {
  const is24HourFormat = userTimeFormat === '24' ? 'HH:mm' : 'hh:mm';

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ overflow: 'visible', paddingTop: '0px' }}>
        <TimePicker
          value={value ? dayjs(value) : null}
          onChange={(newValue) => handleChange(newValue)}
          format={is24HourFormat} 
          slotProps={{
            textField: {
              size: 'small',
              sx: {
                width: '100%',
              },
              variant: 'standard',
            },
            openPickerButton: {
              disableRipple: true,
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CustomPropertyTimePicker;
